module.exports = __webpack_public_path__ + "img/seo_gchess_item05.460ecfb.webp";